import { render, staticRenderFns } from "./menu5.vue?vue&type=template&id=b2a697a2&scoped=true"
import script from "./menu5.vue?vue&type=script&lang=js"
export * from "./menu5.vue?vue&type=script&lang=js"
import style0 from "./menu5.vue?vue&type=style&index=0&id=b2a697a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2a697a2",
  null
  
)

export default component.exports